var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    fillRule: "nonzero",
    d: "M8.818 22.498v-8.999h2.731l.447-3.999H8.818V7.552c0-1.029.027-2.052 1.465-2.052h1.457V2.641c0-.043-1.251-.141-2.517-.141-2.645 0-4.3 1.657-4.3 4.699V9.5H2v3.999h2.923v8.999h3.895z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3d52c083a19989e23b5b3bd4c4f031f0.svg";
export { ForwardRef as ReactComponent };